<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-select
                    label="Tipo"
                    text-field="nome"
                    value-field="id"
                    v-model="model.tipoId"
                    :options="form.tipos"
                    :validations="validations.tipo"
                    show-default-option
                    :disabled="id && desabilitaTipo ? true : false"
                />
            </rkm-col>
            <rkm-col cols="2">
                <rkm-form-select
                    label="Grupo"
                    text-field="nome"
                    value-field="id"
                    v-model="model.grupoTipoId"
                    :options="form.grupos"
                    :validations="validations.grupo"
                    :disabled="id && desabilitaTipo ? true : false"
                    @change="handleGrupoChange"
                    show-default-option
                />
            </rkm-col>
            <rkm-col cols="2">
                <rkm-form-input
                    label="Sigla"
                    v-model="model.siglaExame"
                    :validations="validations.siglaExame"
                />
            </rkm-col>
            <rkm-col>
                <rkm-form-input
                    label="Nome"
                    v-model="model.nome"
                    :validations="validations.nome"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    v-model="model.exigeProcedimento"
                    inline
                    :label="false"
                    @change="exigeProcedimento"
                >
                    Exige procedimento
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    v-model="model.exigeCodigoAb"
                    inline
                    :label="false"
                    @change="exigeCodigoAb"
                >
                    Exige código AB
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col v-if="!model.exigeCodigoAb">
                <rkm-form-input-autocomplete
                    :repository="repositories.procedimento"
                    :requestQueryStringParams="autocompletesResquestParams.queryString"
                    :searchFields="fields.autocompletes.procedimento"
                    label="Procedimento"
                    v-model="model.procedimento"
                    :disabled="seleciona ? false : true"
                    :validations="model.exigeProcedimento ? validations.procedimento: {}"
                 >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-radio-group v-model="model.searchByApelido">
                                <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input-autocomplete>
            </rkm-col>

            <rkm-col v-else>
                <rkm-form-input-autocomplete
                    :repository="repositories.codigoAb"
                    :searchFields="fields.autocompletes.codigoAb"
                    :text-field="item => `${item.codigo} - ${item.descricao}`"
                    label="Código AB"
                    v-model="model.codigoAb"
                    :validations="model.exigeCodigoAb ? validations.codigoAb : {}"
                />
            </rkm-col>

            <rkm-col cols="2" v-if="seleciona == false || model.exigeProcedimento == false || model.exigeCodigoAb == true">
                <rkm-form-select
                    label="Sexo"
                    v-model="model.sexoId"
                    default-option-text="AMBOS"
                    value-field="id"
                    text-field="descricao"
                    :options="form.sexos"
                    show-default-option
                    :validations="model.sexoId"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    label="Observação"
                    v-model="model.observacao"
                    name="observacao"
                    row="3"
                    max-rows="3"
                    :validations="validations.observacao"
                >
                </rkm-form-textarea>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox
                    v-model="model.permiteEnvioWhatsapp"
                    :label="false"
                    inline
                >
                    Permitir envio por WhatsApp
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :disabled="!model.isRegulado"
                    :label="false"
                    :options="form.regulacaoTipos"
                    :validations="validations.regulacaoTipo"
                    name="Tipo de regulação"
                    show-default-option
                    text-field="nome"
                    v-model="model.regulacaoTipoId"
                    value-field="id"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                :disabled="model.exigeCodigoAb"
                                @change="handleReguladoChange"
                                v-model="model.isRegulado"
                            >
                                Regulado
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-prepend>

                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                :disabled="!model.isRegulado"
                                @change="handlePpiChange"
                                v-model="model.isPpi"
                            >
                                PPI
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-select>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :disabled="!model.isPpi"
                    :validations="validations.valorPpi"
                    key="valorPpi"
                    label="Valor PPI"
                    ref="valorPpi"
                    prepend="R$"
                    v-model="model.valorPpi"
                    v-money="money"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :validations="validations.tempoMedioPrevistoAtendimentoDias"
                    label="Tempo médio previsto para atendimento (dias)"
                    number
                    tooltip-top="Informe o tempo médio de espera, que o paciente aguardará para ser atendido."
                    v-model="model.tempoMedioPrevistoAtendimentoDias"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    v-model="model.ativo"
                    :label="false"
                    inline
                >
                    Ativo
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-area
            no-margin-top
            title="Regras de Solicitação"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="8">
                    <rkm-form-multiselect
                        :load-all-automatically="false"
                        :options="form.ocupacoes"
                        :select-limit="null"
                        allow-search
                        drop-up
                        label="CBOs autorizados para solicitação"
                        option-name-key="descricao"
                        option-text-selecteds="CBO autorizado"
                        uniform-checkbox
                        v-model="model.ocupacoes"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Permitir nova solicitação com exame ativo"
                        v-model="model.permiteRepeticao"
                    >
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>

// Mixins.
import { repository } from '@/mixins'

// Directives.
import { VMoney } from 'v-money'

export default {
    computed: {
        autocompletesResquestParams() {

            return {
                queryString: {
                    exames: true,
                    search_by_apelido: this.model.searchByApelido,
                },
            }
        },
        fields() {

            return {
                autocompletes: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                    codigoAb: [{ key: 'codigo', searchable: true }, { key: 'descricao', searchable: true }],
                }
            }
        },
        validations() {

            return {
                procedimento: { required: true },
                codigoAb: { required: true },
                sexoId: { required: true },
                nome: { required: true, min: 3, max: 180 },
                tipo: { required: true },
                grupo: { required : true },
                siglaExame: { required : true, min: 2, max: 5 },
                regulacaoTipo: { required: this.model.isRegulado },
                valorPpi: { max: 11 },
                observacao: {
                    max: 5000,
                    min: 3,
                },
                tempoMedioPrevistoAtendimentoDias: { max: 4, min_value: 1 },
            }
        },
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            grupo: this.getConectaSusRepository('cadastro.grupo'),
            agendamento: this.getConectaSusRepository('exameImagem.agendamento'),
        }

        this.repositories.codigoAb = {
            autocomplete: params => this.repositories.exame.codigoAbAutocomplete(params),
        }

        this.load();
    },
    data: () => ({
        desabilitaTipo: false,
        seleciona: true,
        money: {
            decimal: ',',
            thousands: '.',
            suffix: '',
            precision: 2,
            masked: false
        },
    }),
    directives: { money: VMoney },
    methods: {
        load() {

            if(this.model.exigeProcedimento == false){

                this.disabledProcedimento()
            }
        },
        validate() {

            return this.$refs.Form.validate()
        },
        disabledInput(){

            this.desabilitaTipo = true
        },
        disabledProcedimento(){

            this.seleciona = false
        },
        exigeProcedimento(){

            if (this.model.exigeProcedimento) {

                this.model.exigeCodigoAb = false
                this.model.codigoAb = null

                this.seleciona = true
                this.model.procedimento = this.model.salvaNomeProcedimento
            } else {

                this.seleciona = false
                this.model.procedimento = null
            }
        },
        exigeCodigoAb(){

            if (this.model.exigeCodigoAb) {

                this.model.exigeProcedimento = false
                this.seleciona = false
                this.model.procedimento = null

                this.model.isRegulado = false
                this.handleReguladoChange()

                this.model.codigoAb = this.model.salvaNomeCodigoAb
            } else {

                this.model.codigoAb = null
            }
        },
        handleGrupoChange() {

            this.handleReguladoChange()

            if (this.model.grupoTipoId) {

                const grupo = this.form.grupos.find(g => g.id === this.model.grupoTipoId)

                this.model.isRegulado = !!grupo.regulacaoTipoId
                this.model.regulacaoTipoId = grupo.regulacaoTipoId
            }
        },
        handleReguladoChange() {

            this.model.regulacaoTipoId = null
            this.model.isPpi = false

            this.handlePpiChange()
        },
        handlePpiChange() {

            this.model.valorPpi = '0,00'
            this.$refs.valorPpi.$el.getElementsByTagName('input')[0].value = '0,00'
        }
    },
    mixins: [repository],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        id: { type: Number },
    },

}
</script>
